/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Preview_Open_EditorInputs */

const cs_blog_preview_open_editor = /** @type {(inputs: Blog_Preview_Open_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít editor`)
};

const en_blog_preview_open_editor = /** @type {(inputs: Blog_Preview_Open_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open full editor`)
};

/**
* | output |
* | --- |
* | "Open full editor" |
*
* @param {Blog_Preview_Open_EditorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_preview_open_editor = /** @type {((inputs?: Blog_Preview_Open_EditorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Preview_Open_EditorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_preview_open_editor(inputs)
	return cs_blog_preview_open_editor(inputs)
});